import { IPromise, IQService } from 'angular';
import { ServiceLocator } from '../../app/ServiceLocator';

/**
 * Creates a standard ES6 promise that wraps the provided $q promise. In unit tests, make sure you await {@link triggerPromiseResolutionInUnitTests}
 * to make sure all the digest cycles and event loops have passed correctly
 * @param qPromise - The $q promise to wrap.
 */
export function toNativePromise<T>(qPromise: IPromise<T>): Promise<T> {
  // ideally, we should only need Promise.resolve to wrap a promise-like, but for some reason, rejected $q promises are
  // not propagated correctly this way. Instead, we're creating a promise manually and resolving/rejecting manually
  return new Promise<T>((resolve, reject) => qPromise.then(resolve, reject));
}

/**
 * Create a $q promise that wraps the provided ES6 promise. In unit tests, make sure you await {@link triggerPromiseResolutionInUnitTests}
 * to make sure all the digest cycles and event loops have passed correctly
 * @param promise - The standard ES6 promise to wrap
 * @param $q - An optional instance of the $q service. If not provided, it will be retrieved from ServiceLocator
 */
export function toQPromise<T>(promise: Promise<T>, $q?: IQService): IPromise<T> {
  const qService = $q ?? ServiceLocator.get<IQService>('$q');
  return qService.resolve(promise);
}
